import { render } from "./ConfirmApplicationDeleteDialog.vue?vue&type=template&id=1936488d"
import script from "./ConfirmApplicationDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmApplicationDeleteDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__